
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BladderUrothelialCarcinoma',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Urology/BladderUrothelialCarcinoma.vue